import { language } from "@chef/constants";

const getIntervalText = (interval: number) => {
  switch (interval) {
    case 10:
      return intl.EVERY_WEEKS;
    case 20:
      return intl.EVERY_EVEN_WEEKS;
    case 30:
      return intl.EVERY_ODD_WEEKS;
    default:
      return "";
  }
};

export const intl = (
  {
    no: {
      YOUR_DELIVERY_HAS_STARTED: "Leveranser startet",
      YOUR_FIRST_DELIVERY_ARRIVES: "Din første matkasse leveres:",
      YOUR_MEALBOX_GETS_DELIVERED: (interval: number) =>
        `Du vil få levert matkasse ${getIntervalText(interval)}.`,
      CHANGE_DELIVERY_INTERVAL_INFO:
        'Du kan enkelt endre leveringsintervallene via "Min konto" eller ved å pause enkelte leveringer i Leveringskalenderen. Endringer må skje senest tirsdag 23.59 før den kommende leveringen.',
      SEE_MY_MENU: "Vis min meny",
      REACTIVATION: "Reaktivert",
      EVERY_WEEKS: "hver uke",
      EVERY_EVEN_WEEKS: "partallsuker",
      EVERY_ODD_WEEKS: "oddetallsuker",
    },
    se: {
      YOUR_DELIVERY_HAS_STARTED: "Leveranser startade",
      YOUR_FIRST_DELIVERY_ARRIVES: "Din första leverans kommer:",
      YOUR_MEALBOX_GETS_DELIVERED: (interval: number) =>
        `Din matkasse levereras  ${getIntervalText(interval)}.`,
      CHANGE_DELIVERY_INTERVAL_INFO:
        'Du kan ändra leveransintervall via "Mitt konto" eller pausa enskilda leveranser via "Min meny". Ändringar kan göras senast [tisdag kl. 23.59] för nästa planerade leverans.',
      SEE_MY_MENU: "Visa min meny",
      REACTIVATION: "Återaktiverad",
      EVERY_WEEKS: "varje vecka",
      EVERY_EVEN_WEEKS: "varannan vecka",
      EVERY_ODD_WEEKS: "varannan vecka",
    },
    dk: {
      YOUR_DELIVERY_HAS_STARTED: "Leveringerne er aktive",
      YOUR_FIRST_DELIVERY_ARRIVES: "Din første måltidskasse leveres:",
      YOUR_MEALBOX_GETS_DELIVERED: (interval: number) =>
        `Du vil få leveret måltidskasser ${getIntervalText(interval)}.`,
      CHANGE_DELIVERY_INTERVAL_INFO:
        'Du kan nemt ændre leveringsintervallet via "Min konto" eller ved at sætte enkelte leveringer på pause via "Min menu". Ændringer skal ske senest [onsdag kl. 23.59] før den kommende levering.',
      SEE_MY_MENU: "Vis min menu",
      REACTIVATION: "Genaktiveret",
      EVERY_WEEKS: "hver uge",
      EVERY_EVEN_WEEKS: "lige ugenumre",
      EVERY_ODD_WEEKS: "ulige ugenumre",
    },
  } as const
)[language];
